import DefaultFormInputs from './DefaultFormInputs';
import generateRender from 'shared/utils/generateRender';

const FormInputs = generateRender({
  default: DefaultFormInputs,
});

export default FormInputs;

